import React from 'react';
import { Modal } from 'react-bootstrap';
import '../componentes/ModalVerificacion.css';
import certificadoFondo from '../data/certificado/certificado_blanco.svg';
import logoAcademia from '../data/inicio/logo.png';

const ModalVerificacion = ({ show, handleClose, data }) => {
    return (
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        backdrop="static"
        dialogClassName="custom-modal-dialog"
      >
        <Modal.Header closeButton className="modal-header">
          <div className="modal-logo-container">
            <img
              src={logoAcademia}
              alt="Logo Academia Pixel"
              className="modal-logo"
            />
            <Modal.Title className="modal-title">
              <i className="bi bi-file-earmark-check me-2"></i>
              Resultados de Verificación
            </Modal.Title>
          </div>
        </Modal.Header>
  
        <Modal.Body className="verification-body">
          {data ? (
            <>
              <div className="participant-legend">
                <div className="certificate-bg">
                  <img src={certificadoFondo} alt="Fondo certificado" />
                </div>
                <div className="frosted-glass"></div> {/* Capa de vidrio esmerilado */}
                <div className="legend-content">
                  <div>
                    <h3 className="certificate-title">Se hace constar que:</h3>
                    
                
                    
                    <p className="certificate-text mb-4">
{/* Usar data.basic para acceder a los datos */}
<strong className="h4">{data?.basic?.nombreCompleto || "Nombre no disponible"}</strong>
<br />
Cédula: <strong>{data?.basic?.cedula || "N/A"}</strong>
<br />
<br />
{(data?.basic?.ultimaVerificacion?.cursos?.length || 0) > 0 ? (
  <>
    Ha completado satisfactoriamente los siguientes cursos:
    <br />
    <mark>{data.basic.ultimaVerificacion.cursos.join(", ")}</mark>
    <br />
    <br />
  </>
) : (
  "No tiene cursos activos verificados"
)}
  
  Cumplió con los requisitos del programa de estudios,<br />
  obteniendo su <mark>Reconocimiento de Participación con Verificación Digital</mark>.
</p>

<div className="last-verification">
  Última verificación: <strong>
    {data?.basic?.ultimaVerificacion?.fecha ? (
      new Date(data.basic.ultimaVerificacion.fecha).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      })
    ) : (
      'No registrada'
    )}
  </strong>
</div>

                  </div>
  
                  <footer className="certificate-footer">
                    Academia Pixel - Educación en tecnología y diseño digital<br />
                    VALENCIA edo. CARABOBO - VENEZUELA
                  </footer>
                </div>
              </div>
            </>
          ) : (
            <div className="text-center py-4">
              <i className="bi bi-x-circle text-danger display-5 mb-3"></i>
              <p className="text-muted">No se encontraron registros para esta cédula</p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  };
  
  export default ModalVerificacion;